<template>
  <section class="bg-[--black] flex flex-col w-full items-center py-[58px] lg:py-[72px]">
    <div class="flex flex-col gap-[20px] w-auto items-center">
      <span class="yellow text-[18px]  md:text-[20px] leading-[115%] lg:border yellow-border px-[29px] py-[5.5px] rounded-full">
        Blog VIP
      </span>
      <h2 class="white text-[30px] md:text-[40px] font-bold max-w-[415px] md:max-w-[525px] text-center">
        Mais notícias sobre a Antecipação do FGTS
      </h2>
      <LinkButton customClass="!py-[12.5px] !px-[25px] !w-full !text-[18px] lg:!w-[288px] !black md:text-[20px]"
        style=" background: linear-gradient(90deg, #FFB706 0%, #FDBF19 52.4%, #FFB706 100%);"
        url="https://blog.vipfinanceira.com.br" label="Acesse o blog" :showIcon="false" />
    </div>

  </section>
</template>
<script>
import LinkButton from "../components/LinkButton.vue";

export default {
  name: "BlogComponent",
  components: {
    LinkButton,
  },
};
</script>
